export default {
  compte: {},
  token: null,
  Farm_List: [],
  véhicule_list: [],
  employés_Table: [],
  tache_list: [],
  Variété_list: [],
  parcelle_list: [],
};
